import { render, staticRenderFns } from "./ResetPasswordForm.vue?vue&type=template&id=b9f1ef58&scoped=true&"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordForm.vue?vue&type=style&index=0&id=b9f1ef58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f1ef58",
  null
  
)

export default component.exports